
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 15v-1.764A2.5 2.5 0 013.882 11l5.342-2.67a.5.5 0 00.276-.448V4.5a2.5 2.5 0 015 0v3.382a.5.5 0 00.276.447L20.118 11a2.5 2.5 0 011.382 2.236V15a.5.5 0 01-.646.478l-6.031-1.836a.25.25 0 00-.323.239V16.5a.5.5 0 00.2.4l1.2.9c.378.283.6.728.6 1.2v2.5a.5.5 0 01-.724.447L12 20.06l-3.776 1.888A.5.5 0 017.5 21.5V19a1.5 1.5 0 01.6-1.2l1.2-.9a.5.5 0 00.2-.4v-2.62a.25.25 0 00-.323-.238l-6.031 1.836A.5.5 0 012.5 15z"}})])
          )
        }
      }
    